import React from 'react';

const PdfGenerationContext = React.createContext(null);

export function PdfGenerationProvider({ children }) {
  const [isPdfGenerating, setIsPdfGenerating] = React.useState(false);

  const value = React.useMemo(
    () => ({
      isPdfGenerating,
      setPdfGenerating: setIsPdfGenerating,
    }),
    [isPdfGenerating]
  );

  return <PdfGenerationContext.Provider value={value}>{children}</PdfGenerationContext.Provider>;
}

export function usePdfGeneration() {
  const context = React.useContext(PdfGenerationContext);
  if (!context) {
    throw new Error('usePdfGeneration must be used within a PdfGenerationProvider');
  }
  return context;
}
